module.exports = __webpack_public_path__ + "img/y_2023.3bc3233b.png";